import {Link} from 'gatsby'
import React, { Component } from 'react'
import { cn, getPageUrl } from '../lib/helpers'


function Offer ({offer}) {
  return(
    <p dangerouslySetInnerHTML={{__html: offer.offer}}></p>
  )
}


Offer.defaultProps = {
  props: {},
}

export default Offer